/**
 * Action Types
 */

import {
  PROGRESS_CLEAR,
  PROGRESS_UPDATE
} from 'redux-types/progress'

const initialState = {
  text: '',
  percent: 0
}

export default function progress_reducer (state = initialState, action) {
  switch (action.type) {
    case PROGRESS_CLEAR:
      return {
        ...initialState
      }

    case PROGRESS_UPDATE:
      return {
        ...state,
        ...action.progress
      }

    default:
      return state
  }
}
